import { Grid } from "@material-ui/core";
import { OpenProps } from "../assetSettingModal/hooks/AssetSettingModalType";
import { PlayerType, TeamType, PositionType } from "../Type/TeamType";
import BottomButtonArea from "./BottomButtonArea";
import CenterButtonArea from "./CenterButtonArea";
import SettingConfirmAreaRow from "./SettingConfirmAreaRow";
import TopButtonArea from "./TopButtonArea";

type Props = {
    openAttackTeamAssetSettingModal: () => void,
    openDefenceTeamAssetSettingModal: () => void,
    attackTeam: TeamType,
    defenceTeam: TeamType,
    switchingTeam: () => void,
    onBattleResultMoveButtonClick: () => void,
    openTeamAssetSettingModal: ({ mode, player, position }: OpenProps) => void,
    setEffectSkilePositionTop: (player: PlayerType, position: PositionType) => void,
    setEffectSkilePositionBottom: (player: PlayerType, position: PositionType) => void
}

const SettingConfirmArea = ({
    openAttackTeamAssetSettingModal,
    openDefenceTeamAssetSettingModal,
    attackTeam,
    defenceTeam,
    switchingTeam,
    onBattleResultMoveButtonClick,
    openTeamAssetSettingModal,
    setEffectSkilePositionTop,
    setEffectSkilePositionBottom
}: Props) => {
    return (
        <Grid container spacing={2} alignItems="center" >
            <TopButtonArea onEditButtonClick={openAttackTeamAssetSettingModal} />
            <SettingConfirmAreaRow
                member={attackTeam.front}
                openTeamAssetSettingModal={openTeamAssetSettingModal}
                teamPlayer="Attack"
                teamPosition="FRONT"
                setEffectSkilePositionTop={setEffectSkilePositionTop}
                setEffectSkilePositionBottom={setEffectSkilePositionBottom}
            />
            <SettingConfirmAreaRow
                member={attackTeam.middle}
                openTeamAssetSettingModal={openTeamAssetSettingModal}
                teamPlayer="Attack"
                teamPosition="MIDDLE"
                setEffectSkilePositionTop={setEffectSkilePositionTop}
                setEffectSkilePositionBottom={setEffectSkilePositionBottom}
            />
            <SettingConfirmAreaRow
                member={attackTeam.back}
                openTeamAssetSettingModal={openTeamAssetSettingModal}
                teamPlayer="Attack"
                teamPosition="BACK"
                setEffectSkilePositionTop={setEffectSkilePositionTop}
                setEffectSkilePositionBottom={setEffectSkilePositionBottom}
            />
            <CenterButtonArea
                onTeamChangeButtonClick={switchingTeam}
                onEditButtonClick={openDefenceTeamAssetSettingModal} />
            <SettingConfirmAreaRow
                member={defenceTeam.front}
                openTeamAssetSettingModal={openTeamAssetSettingModal}
                teamPlayer="Defence"
                teamPosition="FRONT"
                setEffectSkilePositionTop={setEffectSkilePositionTop}
                setEffectSkilePositionBottom={setEffectSkilePositionBottom}
            />
            <SettingConfirmAreaRow
                member={defenceTeam.middle}
                openTeamAssetSettingModal={openTeamAssetSettingModal}
                teamPlayer="Defence"
                teamPosition="MIDDLE"
                setEffectSkilePositionTop={setEffectSkilePositionTop}
                setEffectSkilePositionBottom={setEffectSkilePositionBottom}
            />
            <SettingConfirmAreaRow
                member={defenceTeam.back}
                openTeamAssetSettingModal={openTeamAssetSettingModal}
                teamPlayer="Defence"
                teamPosition="BACK"
                setEffectSkilePositionTop={setEffectSkilePositionTop}
                setEffectSkilePositionBottom={setEffectSkilePositionBottom}
            />
            <BottomButtonArea onBattleResultMoveButtonClick={onBattleResultMoveButtonClick} />
        </Grid>
    );
}

export default SettingConfirmArea;
